export default __webpack_public_path__ + "static/media/apaches-series.18b8cd42.webp";